module.exports = __webpack_public_path__ + "static/media/GooglePlay.7b1494a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/GooglePlay.svg
// module id = 93
// module chunks = 0